import { render, staticRenderFns } from "./ShopFooter.vue?vue&type=template&id=7dbf5e5f&scoped=true&"
import script from "./ShopFooter.vue?vue&type=script&lang=js&"
export * from "./ShopFooter.vue?vue&type=script&lang=js&"
import style0 from "./ShopFooter.vue?vue&type=style&index=0&id=7dbf5e5f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf5e5f",
  null
  
)

export default component.exports
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QFooter,QToolbar,QBtn,QSpace,QDialog,QCard,QCardSection,QSeparator,QCardActions});qInstall(component, 'directives', {ClosePopup});
